import { buffers } from 'redux-saga';
import type { History, Location } from 'history';
import { put, take, call, cancelled, SagaReturnType } from 'redux-saga/effects';
import { pathOr } from 'ramda';
import { createRouterChannel } from '../../channels';
import { ROOT } from '../../../constants/routeTemplates';
import { DEFAULT_CHANNEL_BUFFER_SIZE as BUFFER_SIZE } from '../../../constants';
import { setCurrentPath } from '../../actions/app/history';

export const buffer = buffers.expanding<Location>(BUFFER_SIZE);

export function* routerSubscriber(history: History) {
  const channel: SagaReturnType<typeof createRouterChannel> = yield call(
    createRouterChannel,
    history,
    buffer
  );
  yield put(setCurrentPath(pathOr(ROOT, ['location', 'pathname'], history)));

  try {
    while (true) {
      const { pathname }: Location = yield take(channel);
      yield put(setCurrentPath(pathname));
    }
  } finally {
    if (yield cancelled()) {
      channel.close();
      // eslint-disable-next-line no-console
      console.info('routerSubscriber cancelled');
    }
  }
}
